import React from "react";
import StarRating from "./StarRating";

const ProductReview = (props) => {
  return (
    <div className="mb-8 md:mb-12">
      <StarRating rating={props.score} text={props.date} />
      <div className="my-2">
        {props.verifiedBuyer && (
          <span className="text-white bg-green-dark px-2 py-1 text-14 mr-2">
            Verified
          </span>
        )}
        <span>{props.name}</span>
      </div>
      {props.title && <h3 className="text-20">{props.title}</h3>}
      <p className="text-gray-light max-w-prose">{props.content}</p>
    </div>
  );
};

export default ProductReview;
